import { Link, useLocation } from "react-router-dom";

const quickLinks = [
  { label: "返回首页", to: "/", icon: "ri-home-4-line" },
  { label: "赛事赛程", to: "/schedule/2025-26", icon: "ri-calendar-2-line" },
  { label: "资讯中心", to: "/news", icon: "ri-newspaper-line" },
];

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-6 pt-32 pb-20 min-h-[70vh] flex flex-col items-center justify-center text-center">
      <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 text-4xl">
        <i className="ri-compass-3-line" aria-hidden="true"></i>
      </span>
      <p className="mt-6 font-heading text-5xl md:text-7xl font-bold text-primary-500">404</p>
      <h1 className="mt-3 font-heading text-xl md:text-3xl font-semibold text-foreground-950">
        没有找到这个页面
      </h1>
      <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg">
        你访问的页面可能已经移动或不存在，试试从下面的入口继续浏览欧冠赛事内容。
      </p>
      <p className="mt-2 text-xs text-foreground-400 font-mono break-all">{location.pathname}</p>

      <div className="mt-8 flex flex-col sm:flex-row flex-wrap justify-center gap-3">
        {quickLinks.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-200 px-5 py-2.5 text-sm font-semibold text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className={l.icon} aria-hidden="true"></i>
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  );
}